import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { useLocation as useLocationContext } from '../../contexts/LocationContext';
import { AuthContext } from '../../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();
  const { ensureFreshLocation } = useLocationContext();
  const auth = useContext(AuthContext);
  const [refreshing, setRefreshing] = useState(false);

  // Hide bottom nav for truck drivers - they have their own nav
  if (auth?.user?.role === 'truck_driver' || auth?.user?.role === 'cdl_driver') {
    return null;
  }

  const navItems = [
    { path: '/', label: t('home'), icon: '🏠' },
    { path: '/time', label: t('time'), icon: '⏰' },
    { path: '/jobs', label: t('jobs'), icon: '💼' },
    { path: '/profile', label: t('profile'), icon: '👤' },
  ];

  const handleNavClick = async (path: string) => {
    // Ensure fresh location before navigating to time clock (uses 5-min cache)
    if (path === '/time') {
      setRefreshing(true);
      try {
        await ensureFreshLocation();
        navigate(path);
      } finally {
        setRefreshing(false);
      }
    } else {
      navigate(path);
    }
  };

  // Get language for loading text
  const lang = localStorage.getItem('language') || 'en';
  const loadingText = lang === 'es' ? 'Obteniendo ubicación...' : 'Getting location...';

  return (
    <>
      {/* Full screen loading overlay when getting location */}
      {refreshing && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(15, 23, 42, 0.95)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 99999,
          padding: '20px'
        }}>
          <Loader2
            size={48}
            style={{
              color: 'white',
              animation: 'spin 1s linear infinite'
            }}
          />
          <div style={{
            color: 'white',
            fontSize: 18,
            marginTop: 20,
            fontWeight: '500'
          }}>
            {loadingText}
          </div>
          <style>{`
            @keyframes spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      )}

      <nav className="bottom-nav" style={{ background: '#000000' }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-around',
          width: '100%',
          height: '60px',
          backgroundColor: 'white',
          borderTop: '1px solid #e5e7eb'
        }}>
          {navItems.map(item => (
            <button
              key={item.path}
              onClick={() => handleNavClick(item.path)}
              disabled={refreshing}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </button>
          ))}
        </div>
      </nav>
    </>
  );
};
